import { ChangeDetectorRef, Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { ModalController, ViewWillEnter } from '@ionic/angular';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import {isNumeric} from "rxjs/internal-compatibility";
import {RequestService} from "../../../../../services/request/request.service";
import Swal2 from 'sweetalert2';
import {ConfirmEmailPage} from 'src/app/components/email-confirm/confirm-email.page';
import{FingerprintAIO}from "@ionic-native/fingerprint-aio/ngx";
import { Capacitor } from '@capacitor/core';

interface SavedWithdrawalAccount {
  alias: string;
  destination: string;
  method?: string;
  bankId?: string;
  bankName?: string;
  receiverName?: string;
  receiverRfc?: string;
  raw?: any;
}

@Component({
  selector: 'app-retiros-paypal',
  templateUrl: './retiros-paypal.component.html',
  styleUrls: ['./retiros-paypal.component.scss'],
})
export class RetirosPaypalComponent implements OnInit, OnChanges, ViewWillEnter {
  selectedBankId: string = '';
  private readonly bbvaFinancialEntityId = '0012';
  private readonly bbvaBankCode = '012';
  private readonly cardBinBankPrefixes = [
    {
      financialEntityId: '0012',
      bins: [
        '409851',
        '410180',
        '410181',
        '415231',
        '418080',
        '418094',
        '441311',
        '441313',
        '455500',
        '455514',
        '455545',
        '493160'
      ],
      ranges: [
        ['455504', '455505']
      ]
    },
    {
      financialEntityId: '0002',
      bins: [
        '405306',
        '407458',
        '429522',
        '455255',
        '491501',
        '517712'
      ],
      ranges: [
        ['408244', '408245']
      ]
    },
    {
      financialEntityId: '0014',
      bins: [
        '493135',
        '547015',
        '547146',
        '557905'
      ],
      ranges: []
    }
  ];


  @Input() profile_id: boolean=false;
  @Input() profileinfo:any;
  public Concepto:any;
  public Alias: string = '';
  public saveAccount = false;
  public HolderName: string = '';
  public receiverName: string = '';
  cardNum;
  image_brand;
  @Input() CLABE: boolean=false;
  public AccountNumber: any;
  public Monto: number= 0; 
  /**
   * BBVA API Market charges a fixed MXN 10 fee for the payout channels used
   * here (BBVA internal, SPEI/CLABE and 16-digit card).  The backend checks
   * `balance >= amount + 10`, so the amount the user can enter is the balance
   * after reserving that fee. Keep this value in one place so the form,
   * validation and confirmation copy cannot drift apart.
   */
  public readonly bbvaPayoutCommission = 10;
  @Input() Interbank:boolean=false;
  @Input() paymentEndpoint: string = null;
  @Input() paymentIdentifier: string = null;
  @Input() balances: any[];
  @Input() balance: any;
  @Input() isRefreshing: boolean = false;
  public withdrawalStep = 1;
  public savedAccounts: SavedWithdrawalAccount[] = [];
  public savedAccountPredictions: SavedWithdrawalAccount[] = [];
  public selectedSavedAccount: SavedWithdrawalAccount = null;
  public savedAccountsLoaded: boolean = false;
  public showSavedAccountPredictions: boolean = false;
  public isEmailConfirmationLoading: boolean = false;
  public confirmationChannel: 'email' | 'whatsapp' | 'sms' =
    Capacitor.getPlatform() === 'web' ? 'email' : 'whatsapp';

  public isBbvaApiPayout(): boolean {
    // These three withdrawal channels are processed by BBVA API Market and
    // all reserve the same MXN 10 commission. Use the channel as the source
    // of truth so the guard still works while a modal is being hydrated (or
    // when an older caller does not pass paymentEndpoint).
    return ['bbva', 'spei', 'card'].includes(
      String(this.paymentIdentifier || '').trim().toLowerCase()
    );
  }

  public get payoutCommission(): number {
    return this.isBbvaApiPayout() ? this.bbvaPayoutCommission : 0;
  }

  public get maxTransferAmount(): number {
    const balance = Number(this.balance);
    if (!Number.isFinite(balance) || balance <= 0) {
      return 0;
    }

    // Round down to cents so a displayed maximum can never fail the backend
    // `amount + fee <= balance` check because of fractional-cent precision.
    return Math.max(0, Math.floor((balance - this.payoutCommission) * 100) / 100);
  }

  public get totalDebitAmount(): number {
    const amount = Number(this.Monto);
    if (!Number.isFinite(amount) || amount <= 0) {
      return 0;
    }

    return Number((amount + this.payoutCommission).toFixed(2));
  }

  onMontoChange(value: string | number | null | undefined): void {
    const parsed = Number(value);
    this.Monto = Number.isFinite(parsed) && parsed > 0 ? parsed : 0;

    // ion-input's native `max` attribute is advisory and does not stop a
    // pasted value. Clamp BBVA/SPEI/card payouts immediately so the user can
    // never submit the gross balance and accidentally omit the commission.
    if (this.isBbvaApiPayout() && this.hasDisplayableBalance() && this.Monto > this.maxTransferAmount) {
      this.Monto = this.maxTransferAmount;
    }
  }

  public getPayoutConfirmationSummary(): string {
    const amount = Number(this.Monto || 0).toFixed(2);
    if (!this.isBbvaApiPayout()) {
      return `Monto a transferir: $${amount} MXN`;
    }

    return `Monto a transferir: $${amount} MXN · Comisión: $${this.payoutCommission.toFixed(2)} MXN · Total descontado: $${this.totalDebitAmount.toFixed(2)} MXN`;
  }


mxBanks = [
  { name: 'ACTINVER', bankCode: '133', financialEntityId: '0133', banxicoKey: '40133' },
  { name: 'AFIRME', bankCode: '062', financialEntityId: '0062', banxicoKey: '40062' },
  { name: 'albo', bankCode: '721', financialEntityId: '0721', banxicoKey: '90721' },
  { name: 'ARCUS FI', bankCode: '706', financialEntityId: '0706', banxicoKey: '90706' },
  { name: 'ASP INTEGRA OPC', bankCode: '659', financialEntityId: '0659', banxicoKey: '90659' },
  { name: 'AZTECA', bankCode: '127', financialEntityId: '0127', banxicoKey: '40127' },
  { name: 'BaBien', bankCode: '166', financialEntityId: '0166', banxicoKey: '37166' },
  { name: 'BAJIO', bankCode: '030', financialEntityId: '0030', banxicoKey: '40030' },
  { name: 'BANAMEX', bankCode: '002', financialEntityId: '0002', banxicoKey: '40002' },
  { name: 'BANCO COVALTO', bankCode: '154', financialEntityId: '0154', banxicoKey: '40154' },
  { name: 'BANCOMEXT', bankCode: '006', financialEntityId: '0006', banxicoKey: '37006' },
  { name: 'BANCOPPEL', bankCode: '137', financialEntityId: '0137', banxicoKey: '40137' },
  { name: 'BANCO S3', bankCode: '160', financialEntityId: '0160', banxicoKey: '40160' },
  { name: 'BANCREA', bankCode: '152', financialEntityId: '0152', banxicoKey: '40152' },
  { name: 'BANJERCITO', bankCode: '019', financialEntityId: '0019', banxicoKey: '37019' },
  { name: 'BANKAOOL', bankCode: '147', financialEntityId: '0147', banxicoKey: '40147' },
  { name: 'BANK OF AMERICA', bankCode: '106', financialEntityId: '0106', banxicoKey: '40106' },
  { name: 'BANK OF CHINA', bankCode: '159', financialEntityId: '0159', banxicoKey: '40159' },
  { name: 'BANOBRAS', bankCode: '009', financialEntityId: '0009', banxicoKey: '37009' },
  { name: 'BANORTE', bankCode: '072', financialEntityId: '0072', banxicoKey: '40072' },
  { name: 'BANREGIO', bankCode: '058', financialEntityId: '0058', banxicoKey: '40058' },
  { name: 'BANSI', bankCode: '060', financialEntityId: '0060', banxicoKey: '40060' },
  { name: 'BANXICO', bankCode: '001', financialEntityId: '2001', banxicoKey: '2001' },
  { name: 'BARCLAYS', bankCode: '129', financialEntityId: '0129', banxicoKey: '40129' },
  { name: 'BBASE', bankCode: '145', financialEntityId: '0145', banxicoKey: '40145' },
  { name: 'BBVA MEXICO', bankCode: '012', financialEntityId: '0012', banxicoKey: '40012' },
  { name: 'BMONEX', bankCode: '112', financialEntityId: '0112', banxicoKey: '40112' },
  { name: 'CAJA POP MEXICA', bankCode: '677', financialEntityId: '0677', banxicoKey: '90677' },
  { name: 'CAJA TELEFONIST', bankCode: '683', financialEntityId: '0683', banxicoKey: '90683' },
  { name: 'CASHI CUENTA', bankCode: '715', financialEntityId: '0715', banxicoKey: '90715' },
  { name: 'CI BOLSA', bankCode: '631', financialEntityId: '0631', banxicoKey: '90631' },
  { name: 'CITI MEXICO', bankCode: '124', financialEntityId: '0124', banxicoKey: '40124' },
  { name: 'CLS', bankCode: '901', financialEntityId: '0901', banxicoKey: '90901' },
  { name: 'CoDi Valida', bankCode: '903', financialEntityId: '0903', banxicoKey: '90903' },
  { name: 'COMPARTAMOS', bankCode: '130', financialEntityId: '0130', banxicoKey: '40130' },
  { name: 'CONSUBANCO', bankCode: '140', financialEntityId: '0140', banxicoKey: '40140' },
  { name: 'COOPDESARROLLO', bankCode: '725', financialEntityId: '0725', banxicoKey: '90725' },
  { name: 'CREDICAPITAL', bankCode: '652', financialEntityId: '0652', banxicoKey: '90652' },
  { name: 'CREDICLUB', bankCode: '688', financialEntityId: '0688', banxicoKey: '90688' },
  { name: 'CRISTOBAL COLON', bankCode: '680', financialEntityId: '0680', banxicoKey: '90680' },
  { name: 'Cuenca', bankCode: '723', financialEntityId: '0723', banxicoKey: '90723' },
  { name: 'Dep y Pag Dig', bankCode: '729', financialEntityId: '0729', banxicoKey: '90729' },
  { name: 'DONDE', bankCode: '151', financialEntityId: '0151', banxicoKey: '40151' },
  { name: 'FINAMEX', bankCode: '616', financialEntityId: '0616', banxicoKey: '90616' },
  { name: 'FINCOMUN', bankCode: '634', financialEntityId: '0634', banxicoKey: '90634' },
  { name: 'FINCO PAY', bankCode: '734', financialEntityId: '0734', banxicoKey: '90734' },
  { name: 'FINTOC', bankCode: '738', financialEntityId: '0738', banxicoKey: '90738' },
  { name: 'FONDEADORA', bankCode: '699', financialEntityId: '0699', banxicoKey: '90699' },
  { name: 'FONDO (FIRA)', bankCode: '685', financialEntityId: '0685', banxicoKey: '90685' },
  { name: 'GBM', bankCode: '601', financialEntityId: '0601', banxicoKey: '90601' },
  { name: 'HEY BANCO', bankCode: '167', financialEntityId: '0167', banxicoKey: '40167' },
  { name: 'HIPOTECARIA FED', bankCode: '168', financialEntityId: '0168', banxicoKey: '37168' },
  { name: 'HSBC', bankCode: '021', financialEntityId: '0021', banxicoKey: '40021' },
  { name: 'ICBC', bankCode: '155', financialEntityId: '0155', banxicoKey: '40155' },
  { name: 'INBURSA', bankCode: '036', financialEntityId: '0036', banxicoKey: '40036' },
  { name: 'INDEVAL', bankCode: '902', financialEntityId: '0902', banxicoKey: '90902' },
  { name: 'INMOBILIARIO', bankCode: '150', financialEntityId: '0150', banxicoKey: '40150' },
  { name: 'INTERCAM BANCO', bankCode: '136', financialEntityId: '0136', banxicoKey: '40136' },
  { name: 'INVEX', bankCode: '059', financialEntityId: '0059', banxicoKey: '40059' },
  { name: 'JP MORGAN', bankCode: '110', financialEntityId: '0110', banxicoKey: '40110' },
  { name: 'KAPITAL', bankCode: '128', financialEntityId: '0128', banxicoKey: '40128' },
  { name: 'KLAR', bankCode: '661', financialEntityId: '0661', banxicoKey: '90661' },
  { name: 'KUSPIT', bankCode: '653', financialEntityId: '0653', banxicoKey: '90653' },
  { name: 'LIBERTAD', bankCode: '670', financialEntityId: '0670', banxicoKey: '90670' },
  { name: 'MASARI', bankCode: '602', financialEntityId: '0602', banxicoKey: '90602' },
  { name: 'Mercado Pago W', bankCode: '722', financialEntityId: '0722', banxicoKey: '90722' },
  { name: 'MexPago', bankCode: '720', financialEntityId: '0720', banxicoKey: '90720' },
  { name: 'MIFEL', bankCode: '042', financialEntityId: '0042', banxicoKey: '40042' },
  { name: 'MIZUHO BANK', bankCode: '158', financialEntityId: '0158', banxicoKey: '40158' },
  { name: 'MONEXCB', bankCode: '600', financialEntityId: '0600', banxicoKey: '90600' },
  { name: 'MUFG', bankCode: '108', financialEntityId: '0108', banxicoKey: '40108' },
  { name: 'MULTIVA BANCO', bankCode: '132', financialEntityId: '0132', banxicoKey: '40132' },
  { name: 'NAFIN', bankCode: '135', financialEntityId: '0135', banxicoKey: '37135' },
  { name: 'NU MEXICO', bankCode: '638', financialEntityId: '0638', banxicoKey: '90638' },
  { name: 'NVIO', bankCode: '710', financialEntityId: '0710', banxicoKey: '90710' },
  { name: 'PAGATODO', bankCode: '148', financialEntityId: '0148', banxicoKey: '40148' },
  { name: 'Peibo', bankCode: '732', financialEntityId: '0732', banxicoKey: '90732' },
  { name: 'PPBALANCEMX', bankCode: '714', financialEntityId: '0714', banxicoKey: '90714' },
  { name: 'PROFUTURO', bankCode: '620', financialEntityId: '0620', banxicoKey: '90620' },
  { name: 'SABADELL', bankCode: '156', financialEntityId: '0156', banxicoKey: '40156' },
  { name: 'SANTANDER', bankCode: '014', financialEntityId: '0014', banxicoKey: '40014' },
  { name: 'SCOTIABANK', bankCode: '044', financialEntityId: '0044', banxicoKey: '40044' },
  { name: 'SHINHAN', bankCode: '157', financialEntityId: '0157', banxicoKey: '40157' },
  { name: 'SPIN BY OXXO', bankCode: '728', financialEntityId: '0728', banxicoKey: '90728' },
  { name: 'STP', bankCode: '646', financialEntityId: '0646', banxicoKey: '90646' },
  { name: 'Swap', bankCode: '730', financialEntityId: '0730', banxicoKey: '90730' },
  { name: 'TESORED', bankCode: '703', financialEntityId: '0703', banxicoKey: '90703' },
  { name: 'TRANSFER', bankCode: '684', financialEntityId: '0684', banxicoKey: '90684' },
  { name: 'TRANSFER DIRECT', bankCode: '727', financialEntityId: '0727', banxicoKey: '90727' },
  { name: 'UALA', bankCode: '138', financialEntityId: '0138', banxicoKey: '40138' },
  { name: 'UNAGRA', bankCode: '656', financialEntityId: '0656', banxicoKey: '90656' },
  { name: 'VALMEX', bankCode: '617', financialEntityId: '0617', banxicoKey: '90617' },
  { name: 'VALUE', bankCode: '605', financialEntityId: '0605', banxicoKey: '90605' },
  { name: 'VE POR MAS', bankCode: '113', financialEntityId: '0113', banxicoKey: '40113' },
  { name: 'VOLKSWAGEN', bankCode: '141', financialEntityId: '0141', banxicoKey: '40141' }
];
  constructor(
    private modalcontroller:ModalController,
    private request:RequestService,
    private faio:FingerprintAIO,
    private cdr: ChangeDetectorRef,
  ) { }
onClabeChange(value: string | number) {
  const clean = String(value ?? '')
    .replace(/\s+/g, '')   // quita espacios
    .replace(/\D/g, '')    // deja solo números
    .slice(0, 18);         // máximo 18 para CLABE

  this.AccountNumber = clean;
  this.autodetectBankFromClabe(clean);
  this.updateSavedAccountPredictions(clean);
}

autodetectBankFromClabe(value?: string) {
  const clabe = String(value ?? this.AccountNumber ?? '')
    .replace(/\s+/g, '')
    .replace(/\D/g, '')
    .slice(0, 18);

  this.AccountNumber = clabe;

  if (clabe.length < 3) {
    this.selectedBankId = '';
    return;
  }

  const bankCode = clabe.slice(0, 3);
  const found = this.mxBanks.find(bank => bank.bankCode === bankCode);

  this.selectedBankId = found?.financialEntityId ?? '';
}

onCardNumberChange(value: string | number) {
  const clean = String(value ?? '')
    .replace(/\s+/g, '')
    .replace(/\D/g, '')
    .slice(0, 16);

  this.cardNum = this.formatCardNumber(clean);
  this.get_card_type(clean);
  this.autodetectBankFromCardBin(clean);
  this.updateSavedAccountPredictions(clean);
}

onInternalAccountChange(value: string | number) {
  const clean = String(value ?? '')
    .replace(/\s+/g, '')
    .replace(/\D/g, '')
    .slice(0, 10);

  this.AccountNumber = clean;
  this.selectedBankId = '0012';
  this.updateSavedAccountPredictions(clean);
}

autodetectBankFromCardBin(value?: string) {
  const clean = String(value ?? this.cardNum ?? '')
    .replace(/\s+/g, '')
    .replace(/\D/g, '')
    .slice(0, 16);

  if (clean.length < 6) {
    this.selectedBankId = '';
    return;
  }

  const bin = clean.slice(0, 6);
  const binNumber = Number(bin);
  const found = this.cardBinBankPrefixes.find((bank) => {
    const exactMatch = bank.bins.includes(bin);
    const rangeMatch = bank.ranges.some(([start, end]) => {
      return binNumber >= Number(start) && binNumber <= Number(end);
    });

    return exactMatch || rangeMatch;
  });

  this.selectedBankId = found?.financialEntityId ?? '';
}

formatCardNumber(value: string | number): string {
  return String(value ?? '')
    .replace(/\s+/g, '')
    .replace(/\D/g, '')
    .slice(0, 16)
    .replace(/(.{4})/g, '$1 ')
    .trim();
}

formatReceiverRfc(event: any) {
  const value = String(event?.target?.value ?? event?.detail?.value ?? '')
    .toUpperCase()
    .replace(/[^A-ZÑ&0-9]/g, '') // también elimina espacios
    .slice(0, 13);

  this.receiverRfc = value;
}
receiverRfc: string = '';



isValidRfc(rfc: string): boolean {
  const cleanRfc = String(rfc || '')
    .toUpperCase()
    .replace(/[^A-ZÑ&0-9]/g, '');

  // Persona moral: 12 caracteres
  // Persona física: 13 caracteres
  const rfcRegex = /^([A-ZÑ&]{3,4})\d{6}([A-Z0-9]{3})$/;

  return rfcRegex.test(cleanRfc) && (cleanRfc.length === 12 || cleanRfc.length === 13);
}

  ngOnInit() {
    this.getprofile();
    this.fetchSavedAccounts();
    this.syncBalancesFromProps();
  }

  ionViewWillEnter(): void {
    this.syncBalancesFromProps();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['balances'] || changes['balance'] || changes['isRefreshing']) {
      this.handleBalancesChange(
        changes['balances']?.currentValue,
        changes['isRefreshing']?.currentValue
      );
    }
  }

  handleBalancesChange(balances?: any[], isRefreshing?: boolean): void {
    if (balances !== undefined) {
      this.balances = Array.isArray(balances) ? [...balances] : balances;
    }

    if (isRefreshing !== undefined) {
      this.isRefreshing = isRefreshing;
    }

    this.syncMxnBalance();

    // A balance refresh can arrive after the user has already typed an
    // amount. Keep the field aligned with the newly available net balance,
    // including the BBVA API Market commission reserve.
    if (this.isBbvaApiPayout() && this.hasDisplayableBalance() && this.Monto > this.maxTransferAmount) {
      this.Monto = this.maxTransferAmount;
    }

    if (this.hasDisplayableBalance()) {
      this.isRefreshing = false;
    }

    this.cdr.detectChanges();
  }

  hasDisplayableBalance(): boolean {
    return this.balance !== undefined && this.balance !== null;
  }

  private syncBalancesFromProps(): void {
    if (this.balances?.length || this.hasDisplayableBalance()) {
      this.handleBalancesChange(this.balances, this.isRefreshing);
      return;
    }

    this.fetchBalances();
  }

  private fetchBalances(): void {
    if (!this.profile_id) {
      return;
    }

    this.isRefreshing = true;
    this.cdr.detectChanges();

    this.request.createRequestGet('Hubble', null, { id: this.profile_id })
      .then((result) => {
        const wallets = this.parseMaybeJson(result);
        if (Array.isArray(wallets) && wallets.length > 0) {
          this.handleBalancesChange(wallets.map((wallet: any) => wallet.balance), false);
        } else {
          this.isRefreshing = false;
          this.cdr.detectChanges();
        }
      })
      .catch((error) => {
        console.error('Error fetching balances for fiat withdrawal:', error);
        this.isRefreshing = false;
        this.cdr.detectChanges();
      });
  }

  private parseMaybeJson(value: any): any {
    if (typeof value !== 'string') {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  private syncMxnBalance(): void {
    const mxnBalance = this.balances?.[0]?.currency_1;
    if (mxnBalance !== undefined && mxnBalance !== null) {
      this.balance = mxnBalance;
    }
  }

  siguiente(){
    this.modalcontroller.create({
      component: ConfirmationComponent,
      cssClass: 'detailsInModal',
      canDismiss: true, // (forced globally for swipe close on all modals)
    }).then((modal) => {
      modal.present();
    })
  }

  fetchSavedAccounts() {
    this.request.createRequestPost('get_saved_accounts', {
      identifier: this.paymentIdentifier,
      method: this.getPaymentMethod()
    })
      .then((response: any) => {
        console.log('get_saved_accounts raw response:', response);
        const parsed = this.parseResponse(response);
        console.log('get_saved_accounts parsed response:', parsed);
        const accounts = this.extractSavedAccounts(parsed);
        console.log('get_saved_accounts extracted accounts:', accounts);
        this.savedAccounts = accounts
          .map((account) => this.normalizeSavedAccount(account))
          .filter((account) => account.destination);
        console.log('get_saved_accounts normalized accounts:', this.savedAccounts);
        this.savedAccountsLoaded = true;
        this.updateSavedAccountPredictions(this.getCurrentDestination());
      })
      .catch((error) => {
        console.error('Error fetching saved withdrawal accounts:', error);
        this.savedAccountsLoaded = true;
      });
  }

  parseResponse(response: any): any {
    if (typeof response !== 'string') {
      return response;
    }

    try {
      return JSON.parse(response);
    } catch (error) {
      return response;
    }
  }

  extractSavedAccounts(response: any): any[] {
    const candidates = [
      response,
      response?.success,
      response?.success?.data,
      response?.success?.accounts,
      response?.data,
      response?.data?.accounts,
      response?.saved_accounts,
      response?.accounts,
      response?.raw,
      response?.raw?.data,
      response?.raw?.accounts,
      response?.raw?.saved_accounts
    ];

    const found = candidates.find((candidate) => Array.isArray(candidate));
    if (found) {
      return found;
    }

    return this.findSavedAccountArrays(response);
  }

  findSavedAccountArrays(value: any): any[] {
    if (!value || typeof value !== 'object') {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    const accountKeys = [
      'saved_accounts',
      'savedAccounts',
      'accounts',
      'destinations',
      'contacts',
      'data',
      'raw',
      'records',
      'items',
      'results'
    ];

    for (const key of accountKeys) {
      const nestedValue = value?.[key];
      if (Array.isArray(nestedValue)) {
        return nestedValue;
      }
      const nestedAccounts = this.findSavedAccountArrays(nestedValue);
      if (nestedAccounts.length) {
        return nestedAccounts;
      }
    }

    return [];
  }

  normalizeSavedAccount(account: any): SavedWithdrawalAccount {
    const nestedAccount = account?.account || account?.destination || account?.beneficiary || account?.contact || {};
    const destination = this.normalizeDigits(
      account?.destination ||
      account?.destination_number ||
      account?.destinationNumber ||
      account?.account_number ||
      account?.accountNumber ||
      account?.AccountNumber ||
      account?.account ||
      account?.account_id ||
      account?.accountId ||
      account?.account_no ||
      account?.accountNo ||
      account?.saved_account ||
      account?.savedAccount ||
      account?.bbva_account ||
      account?.bbvaAccount ||
      account?.internal_account ||
      account?.internalAccount ||
      account?.clabe ||
      account?.CLABE ||
      account?.card ||
      account?.card_number ||
      account?.cardNumber ||
      account?.number ||
      account?.cuenta ||
      account?.tarjeta ||
      account?.directionNumber ||
      account?.direction_number ||
      nestedAccount?.destination ||
      nestedAccount?.number ||
      nestedAccount?.account_number ||
      nestedAccount?.accountNumber ||
      nestedAccount?.clabe ||
      nestedAccount?.card ||
      nestedAccount?.cardNumber
    );
    const bankId = String(
      account?.selectedBankId ||
      account?.financialEntityId ||
      account?.financial_entity_id ||
      account?.bankId ||
      account?.bank_id ||
      nestedAccount?.selectedBankId ||
      nestedAccount?.financialEntityId ||
      nestedAccount?.financial_entity_id ||
      nestedAccount?.bankId ||
      nestedAccount?.bank_id ||
      ''
    );
    let method = String(
      account?.method ||
      account?.type ||
      account?.identifier ||
      account?.paymentIdentifier ||
      account?.payment_identifier ||
      account?.transfer_type ||
      account?.transferType ||
      ''
    ).toLowerCase();

    if (!method) {
      if (account?.internal_transfer || account?.internalTransfer) {
        method = 'bbva';
      } else if (account?.spei_transfer || account?.speiTransfer) {
        method = 'spei';
      } else if (account?.card_transfer || account?.cardTransfer) {
        method = 'card';
      }
    }

    return {
      alias: String(
        account?.alias ||
        account?.name ||
        account?.contact_alias ||
        account?.contactAlias ||
        account?.beneficiary_alias ||
        account?.beneficiaryAlias ||
        nestedAccount?.alias ||
        nestedAccount?.name ||
        ''
      ).trim(),
      destination,
      method,
      bankId,
      bankName: account?.bankName || account?.bank_name || nestedAccount?.bankName || nestedAccount?.bank_name || this.getBankName(bankId),
      receiverName: String(account?.receiverName || account?.receiver_name || nestedAccount?.receiverName || nestedAccount?.receiver_name || '').trim(),
      receiverRfc: this.normalizeReceiverRfc(
        account?.receiverRfc ||
        account?.receiverRFC ||
        account?.receiver_rfc ||
        account?.rfc ||
        account?.RFC ||
        account?.fiscalNumber ||
        account?.fiscal_number ||
        account?.taxpayer ||
        nestedAccount?.receiverRfc ||
        nestedAccount?.receiverRFC ||
        nestedAccount?.receiver_rfc ||
        nestedAccount?.rfc ||
        nestedAccount?.RFC ||
        nestedAccount?.fiscalNumber ||
        nestedAccount?.fiscal_number ||
        nestedAccount?.taxpayer
      ),
      raw: account
    };
  }

  getPaymentMethod(): string {
    if (this.paymentIdentifier === 'openpay') {
      return 'openpay';
    }

    if (this.CLABE) {
      return 'spei';
    }

    if (this.Interbank) {
      return 'card';
    }

    return 'bbva';
  }

  getCurrentDestination(): string {
    return this.normalizeDigits(this.Interbank && !this.CLABE ? this.cardNum : this.AccountNumber);
  }

  normalizeDigits(value: any): string {
    return String(value ?? '').replace(/\D/g, '');
  }

  normalizeReceiverRfc(value: any): string {
    return String(value ?? '')
      .toUpperCase()
      .replace(/[^A-ZÑ&0-9]/g, '')
      .slice(0, 13);
  }

  onDestinationFocus() {
    this.showSavedAccountPredictions = true;
    if (!this.savedAccountsLoaded) {
      this.fetchSavedAccounts();
    } else {
      this.updateSavedAccountPredictions(this.getCurrentDestination());
    }
  }

  onDestinationBlur() {
    setTimeout(() => {
      this.showSavedAccountPredictions = false;
    }, 180);
  }

  updateSavedAccountPredictions(value: string | number) {
    const query = this.normalizeDigits(value);
    const method = this.getPaymentMethod();
    const previousSavedAccount = this.selectedSavedAccount;
    const methodAccounts = this.savedAccounts.filter((account) => this.accountMatchesMethod(account, method));
    const matchingAccounts = query
      ? methodAccounts.filter((account) => account.destination.includes(query) || query.includes(account.destination))
      : methodAccounts;

    this.savedAccountPredictions = matchingAccounts.slice(0, 5);
    console.log('saved account predictions:', {
      method,
      query,
      savedAccounts: this.savedAccounts,
      methodAccounts,
      predictions: this.savedAccountPredictions
    });
    this.selectedSavedAccount = this.findExactSavedAccount(query, method);

    if (this.selectedSavedAccount) {
      this.Alias = this.selectedSavedAccount.alias;
      this.receiverName = this.selectedSavedAccount.receiverName || '';
      if (this.selectedSavedAccount.bankId) {
        this.selectedBankId = this.selectedSavedAccount.bankId;
      }
      if (this.selectedSavedAccount.receiverRfc) {
        this.receiverRfc = this.normalizeReceiverRfc(this.selectedSavedAccount.receiverRfc);
      }
    } else if (previousSavedAccount && this.Alias === previousSavedAccount.alias) {
      this.Alias = '';
      this.receiverName = '';
    } else if (!query) {
      this.Alias = '';
    }
  }

  accountMatchesMethod(account: SavedWithdrawalAccount, method: string): boolean {
    const matchesByDestinationLength = (
      ((method === 'spei' || method === 'openpay') && account.destination.length === 18) ||
      (method === 'bbva' && account.destination.length === 10) ||
      (method === 'card' && account.destination.length >= 14 && account.destination.length <= 16)
    );

    if (!account.method) {
      return matchesByDestinationLength;
    }

    return account.method.includes(method) ||
      matchesByDestinationLength ||
      (method === 'card' && (account.method.includes('visa') || account.method.includes('tarjeta'))) ||
      (method === 'bbva' && account.method.includes('internal')) ||
      (method === 'spei' && account.method.includes('clabe'));
  }

  findExactSavedAccount(destination: string, method: string): SavedWithdrawalAccount {
    if (!destination) {
      return null;
    }

    return this.savedAccounts.find((account) => {
      return this.accountMatchesMethod(account, method) && account.destination === destination;
    }) || null;
  }

  selectSavedAccount(account: SavedWithdrawalAccount) {
    if (!account) {
      return;
    }

    this.selectedSavedAccount = account;
    this.Alias = account.alias;
    this.receiverName = account.receiverName || '';
    if (account.bankId) {
      this.selectedBankId = account.bankId;
    }
    if (account.receiverRfc) {
      this.receiverRfc = this.normalizeReceiverRfc(account.receiverRfc);
    }

    if (this.Interbank && !this.CLABE) {
      this.cardNum = this.formatCardNumber(account.destination);
      this.get_card_type(account.destination);
    } else {
      this.AccountNumber = account.destination;
    }

    this.showSavedAccountPredictions = false;
  }

  getBankName(bankId: string): string {
    return this.mxBanks.find((bank) => bank.financialEntityId === bankId)?.name || '';
  }

  getMaskedDestination(destination: string): string {
    const clean = this.normalizeDigits(destination);
    if (clean.length <= 4) {
      return clean;
    }

    return `${'*'.repeat(Math.max(clean.length - 4, 0))}${clean.slice(-4)}`;
  }

  getWithdrawalMethodLabel(): string {
    if (this.paymentIdentifier === 'openpay') {
      return 'Retiro bancario Openpay';
    }

    if (this.Interbank && !this.CLABE) {
      return 'Tarjeta de débito o crédito';
    }

    if (this.CLABE) {
      return 'Transferencia interbancaria SPEI';
    }

    return 'Transferencia a cuenta BBVA';
  }

  getWithdrawalMethodIcon(): string {
    if (this.paymentIdentifier === 'openpay') {
      return 'business-outline';
    }

    if (this.Interbank && !this.CLABE) {
      return 'card-outline';
    }

    if (this.CLABE) {
      return 'swap-horizontal-outline';
    }

    return 'wallet-outline';
  }

  getWithdrawalDestinationLabel(): string {
    if (this.Interbank && !this.CLABE) {
      return 'Tarjeta';
    }

    if (this.CLABE) {
      return 'CLABE interbancaria';
    }

    return 'Cuenta BBVA';
  }

  getConfirmationChannelLabel(): string {
    if (this.confirmationChannel === 'whatsapp') return 'WhatsApp';
    if (this.confirmationChannel === 'sms') return 'SMS';
    return 'correo electrónico';
  }

  getConfirmationRecipient(): string {
    if (this.confirmationChannel === 'email') {
      return this.profileinfo?.user?.email || 'tu correo registrado';
    }

    return this.profileinfo?.profile?.telefono
      || this.profileinfo?.telefono
      || this.profileinfo?.user?.telefono
      || 'tu teléfono registrado';
  }

  getConfirmationRecipientForPhone(): string {
    return this.profileinfo?.profile?.telefono
      || this.profileinfo?.telefono
      || this.profileinfo?.user?.telefono
      || 'teléfono registrado';
  }

  private showWithdrawalValidation(title: string, text: string): void {
    Swal2.fire({
      title,
      text,
      icon: 'error',
      confirmButtonText: 'OK',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
    });
  }

  private showVerificationCodeDeliveryError(error: any): void {
    this.setEmailConfirmationLoading(false);
    const payload = error?.error ?? error;
    const message = payload?.title || payload?.message || 'No se pudo enviar el código. Intenta con otro canal.';
    Swal2.fire({
      title: 'No se pudo enviar el código',
      text: message,
      icon: 'error',
      confirmButtonText: 'Entendido',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
    });
  }

  validateDestinationStep(): boolean {
    if (!this.validateReceiverName()) {
      return false;
    }
    if (!this.validateOpenpayHolderName()) {
      return false;
    }

    if (!this.validateBbvaChannelDestination()) {
      return false;
    }

    const destination = this.getCurrentDestination();
    const requiredLength = this.Interbank && !this.CLABE
      ? 16
      : this.CLABE
        ? 18
        : 10;

    if (destination.length !== requiredLength) {
      const label = this.getWithdrawalDestinationLabel();
      this.showWithdrawalValidation(
        'Destino incompleto',
        `${label} debe tener ${requiredLength} dígitos.`
      );
      return false;
    }

    if ((this.Interbank || this.CLABE) && this.paymentIdentifier !== 'openpay') {
      if (!this.receiverRfc?.trim()) {
        this.showWithdrawalValidation('RFC requerido', 'Ingresa el RFC del beneficiario antes de continuar.');
        return false;
      }

      if (!this.isValidRfc(this.receiverRfc)) {
        this.showWithdrawalValidation('RFC inválido', 'Corrige el RFC del beneficiario antes de continuar.');
        return false;
      }
    }

    return this.validateAlias();
  }

  advanceWithdrawalStep(): void {
    if (this.isEmailConfirmationLoading) {
      return;
    }

    if (this.withdrawalStep === 1) {
      if (this.validateDestinationStep()) {
        this.withdrawalStep = 2;
      }
      return;
    }

    if (this.withdrawalStep === 2) {
      if (!this.validatePayoutAmount()) {
        return;
      }

      if (this.CLABE && !this.Concepto?.trim()) {
        this.showWithdrawalValidation('Concepto requerido', 'Ingresa el motivo del retiro antes de revisar la operación.');
        return;
      }

      this.withdrawalStep = 3;
      return;
    }

    this.Retirar();
  }

  previousWithdrawalStep(): void {
    if (this.isEmailConfirmationLoading) {
      return;
    }

    this.withdrawalStep = Math.max(1, this.withdrawalStep - 1);
  }

  requiresAlias(): boolean {
    return !!this.getCurrentDestination() && (!this.isBbvaApiPayout() || this.saveAccount);
  }

  validateAlias(): boolean {
    if (!this.requiresAlias() || this.Alias?.trim()) {
      return true;
    }

    Swal2.fire({
      title: 'Alias requerido',
      text: this.isBbvaApiPayout()
        ? 'Ingresa un alias para guardar este destino.'
        : 'El alias del destino es obligatorio para ejecutar el retiro.',
      icon: 'error',
      confirmButtonText: 'OK',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
    });
    return false;
  }

  validateReceiverName(): boolean {
    if (!this.isBbvaApiPayout()) return true;
    this.receiverName = String(this.receiverName || '').trim().replace(/\s+/g, ' ');
    if (this.receiverName.length >= 2 && this.receiverName.length <= 80) return true;

    this.showWithdrawalValidation('Beneficiario requerido', 'Ingresa el nombre completo del titular de la cuenta destino.');
    return false;
  }

  validateOpenpayHolderName(): boolean {
    if (this.paymentIdentifier !== 'openpay' || this.HolderName?.trim()) {
      return true;
    }

    Swal2.fire({
      title: 'Titular requerido',
      text: 'Ingresa el nombre completo del titular de la cuenta bancaria.',
      icon: 'error',
      confirmButtonText: 'OK',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
    });
    return false;
  }

  validatePayoutAmount(): boolean {
    const amount = Number(this.Monto);
    const balance = Number(this.balance);

    if (!Number.isFinite(amount) || amount <= 0) {
      Swal2.fire({
        title: 'Monto inválido',
        text: 'Ingresa un monto mayor que cero.',
        icon: 'error',
        confirmButtonText: 'OK',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
      return false;
    }

    // Openpay debits its own customer balance and does not use the Hubble
    // balance or the BBVA API Market fee reserve.
    if (this.paymentIdentifier === 'openpay') {
      return true;
    }

    if (!Number.isFinite(balance) || balance <= 0) {
      Swal2.fire({
        title: 'Saldo no disponible',
        text: 'No hay saldo disponible para realizar este retiro.',
        icon: 'error',
        confirmButtonText: 'OK',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
      return false;
    }

    const maxAmount = this.maxTransferAmount;
    const totalDebit = Number((amount + this.payoutCommission).toFixed(2));
    if (amount > maxAmount || totalDebit > balance) {
      const message = this.isBbvaApiPayout()
        ? `El máximo transferible es $${maxAmount.toFixed(2)} MXN después de reservar la comisión de $${this.payoutCommission.toFixed(2)} MXN.`
        : `El máximo transferible es $${maxAmount.toFixed(2)} MXN.`;
      Swal2.fire({
        title: 'Monto superior al disponible',
        text: message,
        icon: 'error',
        confirmButtonText: 'OK',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      });
      return false;
    }

    return true;
  }

  setEmailConfirmationLoading(isLoading: boolean) {
    this.isEmailConfirmationLoading = isLoading;
  }

  Retirar(){
    //this.faio.isAvailable().then(()=>{
      //this.faio.show({}).then((val)=>{
       // alert(JSON.stringify(val));
    if (this.isEmailConfirmationLoading) {
      return;
    }
    if (!this.validateAlias()) {
      return;
    }
    if (!this.validateReceiverName()) {
      return;
    }
    if (!this.validateOpenpayHolderName()) {
      return;
    }
    if (!this.validateBbvaChannelDestination()) {
      return;
    }
    if (!this.validatePayoutAmount()) {
      return;
    }
    if (this.CLABE===false){
      if (this.Interbank===true){//visa
          if (!this.cardNum) {
            Swal2.fire({
              title: 'Error',
              text: 'Debes ingresar una tarjeta.',
              icon: 'error',
              confirmButtonText: 'OK',
              color: '#ffffff',
              background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
            });
            return;
            }
          if (this.getCurrentDestination().length !== 16) {
            Swal2.fire({
              title: 'Error',
              text: 'La tarjeta debe tener 16 dígitos.',
              icon: 'error',
              confirmButtonText: 'OK',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
            return;
          }
      
        let data = {
          email: this.profileinfo.user.email,
          monto: this.Monto,
          divisa: 'MXN',
          verification_channel: this.isBbvaApiPayout() ? this.confirmationChannel : 'email'
        };
        
        // Step 1: Request email confirmation
        this.setEmailConfirmationLoading(true);
        this.request.createRequestPost('send-email-retiros', data)
          .then(response => {
          console.log('response', response);
          let responseData;
          if (Capacitor.getPlatform() !== 'web') {
           responseData = JSON.parse(response);
          }else{
            responseData = response;
          }
          console.log('response code', responseData.code);
          if (responseData.code === 200) {
          const modal = this.modalcontroller.create({
            component: ConfirmEmailPage,
            cssClass: 'detailsInModal',
            canDismiss: true, // (forced globally for swipe close on all modals)
            componentProps: {
            amount: this.Monto,
            currency: 'MXN',
            destination: this.getCurrentDestination(),
            concepto: this.Concepto,
            alias: this.Alias,
            saveAccount: this.saveAccount,
            fee: this.payoutCommission,
            email: this.profileinfo.user.email,
            confirmationChannel: this.isBbvaApiPayout() ? this.confirmationChannel : 'email',
            profile_id: this.profile_id,
            metodo: 'VISA',
            receiverRfc:this.receiverRfc,
            receiverName: this.receiverName,
            selectedBankId:this.selectedBankId,
            bankName: this.getBankName(this.selectedBankId),
            paymentEndpoint: this.paymentEndpoint,
            paymentIdentifier: this.paymentIdentifier
            },
          }).then(modal => {
            modal.onDidDismiss().then(data => {
            // Handle modal dismissal
            });
            modal.present().finally(() => {
              this.setEmailConfirmationLoading(false);
            });
          }).catch(error => {
            this.setEmailConfirmationLoading(false);
            console.error('Error opening confirmation modal:', error);
          });
        
          // Email confirmation sent successfully
          console.log("Profile info and user exist. Displaying alert...");
        
          alert(
            `Confirmacion de retiro\n\n` +
            `Código enviado por ${this.getConfirmationChannelLabel()} a ${this.getConfirmationRecipient()}.\n` +
            this.getPayoutConfirmationSummary()
          );
          console.log("Alert displayed successfully.");
        
        } else {
          this.setEmailConfirmationLoading(false);
          this.showVerificationCodeDeliveryError(responseData);
        }
          })
          .catch(error => {
          console.error("Error:", error);
          this.showVerificationCodeDeliveryError(error);
          });
      }else{//Numero de cuenta BBVA
        if (!this.AccountNumber) {
          Swal2.fire({
            title: 'Error',
            text: 'Debes ingresar una número de cuenta de 10 posiciones.',
              icon: 'error',
              confirmButtonText: 'OK',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
          });
          return;
        }
        if (this.getCurrentDestination().length !== 10) {
          alert('Error\n\nLa cuenta BBVA debe tener 10 dígitos.');
          return;
        }
	      
        let data = {
          email: this.profileinfo.user.email,
          monto: this.Monto,
          divisa: 'MXN',
          verification_channel: this.isBbvaApiPayout() ? this.confirmationChannel : 'email'
        };
        
        // Step 1: Request email confirmation
        this.setEmailConfirmationLoading(true);
        this.request.createRequestPost('send-email-retiros', data)
          .then(response => {
          console.log('response', response);
          let responseData;
          if (Capacitor.getPlatform() !== 'web') {
           responseData = JSON.parse(response);
          }else{
            responseData = response;
          }
          console.log('response code', responseData.code);
          if (responseData.code === 200) {
          const modal = this.modalcontroller.create({
            component: ConfirmEmailPage,
            cssClass: 'detailsInModal',
            canDismiss: true, // (forced globally for swipe close on all modals)
            componentProps: {
            amount: this.Monto,
            currency: 'MXN',
            destination: this.getCurrentDestination(),
            concepto: this.Concepto,
            alias: this.Alias,
            saveAccount: this.saveAccount,
            fee: this.payoutCommission,
            email: this.profileinfo.user.email,
            confirmationChannel: this.isBbvaApiPayout() ? this.confirmationChannel : 'email',
            profile_id: this.profile_id,
            metodo: 'BBVA',
            bankName: this.getBankName(this.selectedBankId) || 'BBVA MEXICO',
            receiverName: this.receiverName,
            paymentEndpoint: this.paymentEndpoint,
            paymentIdentifier: this.paymentIdentifier
            },
          }).then(modal => {
            modal.onDidDismiss().then(data => {
            // Handle modal dismissal
            });
            modal.present().finally(() => {
              this.setEmailConfirmationLoading(false);
            });
          }).catch(error => {
            this.setEmailConfirmationLoading(false);
            console.error('Error opening confirmation modal:', error);
          });
        
          // Email confirmation sent successfully
          console.log("Profile info and user exist. Displaying alert...");
        
          alert(
            `Confirmacion de retiro\n\n` +
            `Código enviado por ${this.getConfirmationChannelLabel()} a ${this.getConfirmationRecipient()}.\n` +
            this.getPayoutConfirmationSummary()
          );
          console.log("Alert displayed successfully.");
        
        } else {
          this.setEmailConfirmationLoading(false);
          this.showVerificationCodeDeliveryError(responseData);
        }
          })
          .catch(error => {
          console.error("Error:", error);
          this.showVerificationCodeDeliveryError(error);
          });
      }

    }else{ //clabe
      if (this.Monto && this.AccountNumber && this.Concepto){

        if (this.CLABE===true){
          // Openpay debits the balance of the authenticated user's Openpay
          // customer. It is not a BBVA/Hubble-balance withdrawal.
          if (!this.AccountNumber) {
            Swal2.fire({
              title: 'Error',
              text: 'Debes ingresar una número de cuenta de 18 posiciones.',
                icon: 'error',
                confirmButtonText: 'OK',
                color: '#ffffff',
                background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
            });
            return;
          }
          if (this.getCurrentDestination().length !== 18) {
            alert('Error\n\nLa CLABE debe tener 18 dígitos.');
            return;
          }
	        
          let data = {
            email: this.profileinfo.user.email,
            monto: this.Monto,
            divisa: 'MXN',
            verification_channel: this.isBbvaApiPayout() ? this.confirmationChannel : 'email'
          };
         
          
          
          // Step 1: Request email confirmation
          this.setEmailConfirmationLoading(true);
          this.request.createRequestPost('send-email-retiros', data)
            .then(response => {
            console.log('response', response);
            let responseData;
            if (Capacitor.getPlatform() !== 'web') {
             responseData = JSON.parse(response);
            }else{
              responseData = response;
            }
            console.log('response code', responseData.code);
            if (responseData.code === 200) {
            const modal = this.modalcontroller.create({
              component: ConfirmEmailPage,
              cssClass: 'detailsInModal',
              canDismiss: true, // (forced globally for swipe close on all modals)
              componentProps: {
              amount: this.Monto,
              currency: 'MXN',
              destination: this.getCurrentDestination(),
              concepto: this.Concepto,
              alias: this.Alias,
              saveAccount: this.saveAccount,
              fee: this.payoutCommission,
              holderName: this.HolderName,
              email: this.profileinfo.user.email,
              confirmationChannel: this.isBbvaApiPayout() ? this.confirmationChannel : 'email',
              profile_id: this.profile_id,
              metodo: this.paymentIdentifier === 'openpay' ? 'OPENPAY' : 'SPEI',
                 receiverRfc:this.receiverRfc,
              receiverName: this.receiverName,
            selectedBankId:this.selectedBankId,
              bankName: this.getBankName(this.selectedBankId),
              paymentEndpoint: this.paymentEndpoint,
              paymentIdentifier: this.paymentIdentifier
              },
            }).then(modal => {
              modal.onDidDismiss().then(data => {
              // Handle modal dismissal
              });
              modal.present().finally(() => {
                this.setEmailConfirmationLoading(false);
              });
            }).catch(error => {
              this.setEmailConfirmationLoading(false);
              console.error('Error opening confirmation modal:', error);
            });
          
            // Email confirmation sent successfully
            console.log("Profile info and user exist. Displaying alert...");
          
            Swal2.fire({
              title: 'Código de confirmación enviado',
              text: `Código enviado por ${this.getConfirmationChannelLabel()} a ${this.getConfirmationRecipient()}.
              ${this.getPayoutConfirmationSummary()}`,
              icon: 'success',
              confirmButtonText: 'Understood',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            }).then(() => {
              console.log("Alert displayed successfully.");
            }).catch(error => {
              console.error("Error displaying alert:", error);
            });
      
          } else {
            this.setEmailConfirmationLoading(false);
            this.showVerificationCodeDeliveryError(responseData);
          }
            })
            .catch(error => {
            console.error("Error:", error);
            this.showVerificationCodeDeliveryError(error);
            // Handle network errors or other unexpected errors here
            });
                

             /*
         this.request.createRequestPost('openPayPayout', { amount: this.Monto, clabe:this.AccountNumber, concepto: this.Concepto})
          .then(response => {
        
              if (response) {
                console.log(response);
                alert("Retiro procesado con exito")
                Swal2.fire({
                  title: 'Retiro enviado con Success',
                  text: 'El retiro ha sido enviado con Success.',
                  icon: 'success',
                  confirmButtonText: 'Understood',
                  color: '#ffffff',
                  background: '#010f4e',
                });
                setTimeout(() => {
                  this.modalcontroller.dismiss()
            
                }, 1200);
              } else {
                  console.error('No response from API call.');
              }
          })
          .catch(error => {
              console.error('Error from API call:', error);  // Log error from API call
          });
          */
        }
  
         
      }else{
        Swal2.fire({
          title: 'Datos faltante',
          text: 'Porfavor llena toda la información',
          icon: 'error',
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
      }
    }
  //},(err)=>{
  //  alert(JSON.stringify(err));
  //})
//},(err)=>{
 // alert("fingerprint not available")
//})
  
  }

  regresar(){
    this.modalcontroller.dismiss()
  }

  private validateBbvaChannelDestination(): boolean {
    if (this.paymentEndpoint !== 'make_a_bbva_api_channel_business_payment') {
      return true;
    }

    const destination = this.getCurrentDestination();
    const isCardPayment = this.Interbank === true && this.CLABE === false;
    const isClabePayment = this.CLABE === true;
    const isBbvaDestination = this.selectedBankId === this.bbvaFinancialEntityId ||
      (isClabePayment && destination.startsWith(this.bbvaBankCode));

    if ((isCardPayment || isClabePayment) && isBbvaDestination) {
      alert(
        'Destino BBVA no permitido\n\n' +
        'Para cuentas BBVA usa la opción BBVA con número de cuenta de 10 dígitos. ' +
        'Las transferencias por tarjeta o CLABE solo pueden enviarse a bancos de terceros.'
      );
      return false;
    }

    return true;
  }

  get_card_type(cardNumber?: string)
  {
    console.log('refactoring card');
    this.image_brand = "";

    //Remove all spaces and dashes from the passed string
    const CardNo = String(cardNumber ?? this.cardNum ?? '').replace(/\D/g, '');

    //Check that the minimum length of the string isn't less
    //than fourteen characters and -is- numeric
    if (CardNo.length < 14 || !isNumeric(CardNo)) {
      this.image_brand = ''
    }

    //Check the first two digits first
    if(parseInt(CardNo.substring(0,2)) === 34 || parseInt(CardNo.substring(0,2)) === 37) {
      this.image_brand = 'assets/icon/pagos/amex.png';

    }else if(parseInt(CardNo.substring(0,2)) >= 51 && parseInt(CardNo.substring(0,2)) <= 55){
      this.image_brand = 'assets/icon/pagos/master_card.png';
    }else if(parseInt(CardNo.substring(0,1)) === 4) {
      this.image_brand = 'assets/icon/pagos/visa.png';
    }








    console.log(this.image_brand);

  }
  getprofile() {
    this.request.createRequestGet("profile-all", null, { id: this.profile_id })
        .then((data => {
            this.profileinfo = JSON.parse(data);
            console.log("Successfully fetched profile info.");
            console.log('ppr', this.profileinfo);
            console.log("Profile info:", this.profileinfo);
            console.log("Email:", this.profileinfo.user.email);

    
        }))
        .catch((error) => {
            console.error("Error fetching profile info:", error);
        });
}
}
